import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useFeatureIntent = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/feature-intent`,
        method: "POST",
        body: data,
      }),
  });
};
